var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState, useEffect } from 'react';
import { Modal, Table, Button, List, Radio, Space, message } from 'antd';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import api from '@/api';
const DeclaredDifficultyHybridModal = ({ visible, onOk, onCancel, initialSelectedData, currentRecord, projectTech, }) => {
    const [categories, setCategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [detailDataList, setDetailDataList] = useState([]);
    const [selectedDetailItem, setSelectedDetailItem] = useState(null);
    const [selectedDetailRowKeys, setSelectedDetailRowKeys] = useState([]);
    const [selectedSwimmerPercentage, setSelectedSwimmerPercentage] = useState('');
    const [selectedCategoryRowKeys, setSelectedCategoryRowKeys] = useState([]);
    useEffect(() => {
        if (visible) {
            // 重置弹框数据
            setSelectedCategory(null);
            setSelectedDetailItem(null);
            setSelectedSwimmerPercentage('100');
            setSelectedCategoryRowKeys([]);
            setSelectedDetailRowKeys([]);
        }
    }, [visible]);
    useEffect(() => {
        if (visible && currentRecord) {
            const fetchCategories = () => __awaiter(void 0, void 0, void 0, function* () {
                const res = yield api.CoachCardApi.getHybridFamilyList({ part: (currentRecord === null || currentRecord === void 0 ? void 0 : currentRecord.part) || '' });
                if (res.data && res.data.code === 200) {
                    const clearOption = { family: '--clear--', code: '--clear--', description: 'Clear this difficulty' };
                    setDetailDataList([]);
                    setCategories([clearOption, ...res.data.data]);
                    // 如果有初始选中数据，尝试匹配分类
                    if (initialSelectedData === null || initialSelectedData === void 0 ? void 0 : initialSelectedData.category) {
                        setSelectedCategory(initialSelectedData.category);
                    }
                    else if (res.data.data.length > 0) {
                        // 默认选中第一个分类
                        setSelectedCategory(res.data.data[0]);
                    }
                }
            });
            fetchCategories();
        }
        else if (!visible) {
            setCategories([]);
            setSelectedCategory(null);
            setDetailDataList([]);
            setSelectedDetailItem(null);
            setSelectedDetailRowKeys([]);
            setSelectedSwimmerPercentage('');
        }
    }, [visible, currentRecord, initialSelectedData]);
    useEffect(() => {
        if (selectedCategory) {
            const fetchDetails = () => __awaiter(void 0, void 0, void 0, function* () {
                var _a;
                if (selectedCategory.code === '--clear--') {
                    setDetailDataList([]);
                    setSelectedDetailItem(null);
                    setSelectedDetailRowKeys([]);
                    return;
                }
                else {
                    const res = yield api.CoachCardApi.getHybridCategories({
                        family_code: selectedCategory.code,
                    });
                    if (res.data && res.data.code === 200) {
                        setDetailDataList([]);
                        setDetailDataList([...res.data.data]);
                        if ((initialSelectedData === null || initialSelectedData === void 0 ? void 0 : initialSelectedData.detail) && ((_a = initialSelectedData.category) === null || _a === void 0 ? void 0 : _a.code) === selectedCategory.code) {
                            setSelectedDetailItem(initialSelectedData.detail);
                            setSelectedDetailRowKeys([initialSelectedData.detail.code + initialSelectedData.detail.dd]);
                        }
                        else {
                            setSelectedDetailItem(null);
                            setSelectedDetailRowKeys([]);
                        }
                    }
                }
            });
            fetchDetails();
        }
        else {
            setDetailDataList([]);
            setSelectedDetailItem(null);
            setSelectedDetailRowKeys([]);
        }
    }, [selectedCategory, initialSelectedData]);
    useEffect(() => {
        if (initialSelectedData === null || initialSelectedData === void 0 ? void 0 : initialSelectedData.percentage) {
            setSelectedSwimmerPercentage(initialSelectedData.percentage);
        }
        else {
            setSelectedSwimmerPercentage('100'); // 确保默认选中 '100% All Swimmers'
        }
    }, [initialSelectedData]);
    const handleCategorySelect = (category) => {
        setSelectedCategory(category);
    };
    const detailColumns = [
        { title: 'Code', dataIndex: 'categoryCode', key: 'categoryCode', width: 80 },
        { title: 'Level', dataIndex: 'level', key: 'level', width: 100 },
        { title: 'DD', dataIndex: 'dd', key: 'dd', width: 80 },
        { title: 'Description', dataIndex: 'description', key: 'description' },
    ];
    const detailRowSelection = {
        type: 'radio',
        selectedRowKeys: selectedDetailRowKeys,
        onChange: (keys, selectedRows) => {
            setSelectedDetailRowKeys(keys);
            setSelectedDetailItem(selectedRows.length > 0 ? selectedRows[0] : null);
        },
    };
    const handleOk = () => __awaiter(void 0, void 0, void 0, function* () {
        onOk(selectedDetailItem ? { category: selectedCategory, detail: selectedDetailItem, percentage: selectedSwimmerPercentage } : null);
        try {
            yield api.CoachCardApi.calculateHybridWithRatio({
                category_code: selectedDetailItem === null || selectedDetailItem === void 0 ? void 0 : selectedDetailItem.categoryCode,
                ratio: selectedSwimmerPercentage,
            });
        }
        catch (error) {
            message.error(error.message);
        }
        (selectedDetailItem === null || selectedDetailItem === void 0 ? void 0 : selectedDetailItem.categoryCode) && (selectedDetailItem.categoryCode = null);
        (selectedDetailItem === null || selectedDetailItem === void 0 ? void 0 : selectedDetailItem.level) && (selectedDetailItem.level = null);
        (selectedDetailItem === null || selectedDetailItem === void 0 ? void 0 : selectedDetailItem.dd) && (selectedDetailItem.dd = null);
        (selectedDetailItem === null || selectedDetailItem === void 0 ? void 0 : selectedDetailItem.description) && (selectedDetailItem.description = null);
        setSelectedDetailRowKeys([]);
    });
    const handleCancel = () => {
        onCancel();
    };
    return (<Modal title="Declared Difficulty Editor (Hybrid)" visible={visible} onOk={handleOk} onCancel={handleCancel} width="80%" bodyStyle={{ minHeight: '40vh', maxHeight: '60vh', overflowY: 'auto' }} footer={[
            <Button key="cancel" onClick={handleCancel} icon={<CloseOutlined />}>
          Cancel
        </Button>,
            <Button key="ok" type="primary" onClick={handleOk} icon={<CheckOutlined />}>
          OK
        </Button>,
        ]}>
      <Space direction="vertical" size="middle" style={{ width: '100%' }}>
        <List size="small" bordered dataSource={categories} style={{ maxHeight: '130px', overflowY: 'auto', fontSize: 12 }} // 添加高度和滚动
     renderItem={(item) => (<List.Item key={item.code} // 添加 key 属性
         onClick={() => handleCategorySelect(item)} style={{
                cursor: 'pointer',
                backgroundColor: (selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.code) === item.code ? '#e6f7ff' : 'transparent',
            }}>
              {item.family}
            </List.Item>)}/>
        <Table rowKey={(record) => `${record.code}-${record.level}-${record.dd !== undefined && record.dd !== null ? record.dd : ''}-${record.description}`} // 复合 rowKey
     rowSelection={detailRowSelection} columns={detailColumns} dataSource={detailDataList} pagination={false} bordered size="small" scroll={{ y: 300 }} // 添加垂直滚动
     onRow={(record) => ({
            onClick: () => {
                setSelectedDetailRowKeys([`${record.code}-${record.level}-${record.dd !== undefined && record.dd !== null ? record.dd : ''}-${record.description}`]);
                setSelectedDetailItem(record);
            },
        })}/>
      </Space>
      <div style={{ marginTop: 20, textAlign: 'start' }}>
        <Radio.Group onChange={(e) => {
            setSelectedSwimmerPercentage(e.target.value);
        }} value={selectedSwimmerPercentage} style={{ width: '100%', display: 'flex', justifyContent: 'flex-start', position: 'absolute', bottom: 10 }}>
          <Radio value="100">100% All Swimmers</Radio>
          <Radio value="50">50% Half of Swimmers</Radio>
          <Radio value="30">30% Less than Half of Swimmers</Radio>
        </Radio.Group>
      </div>
    </Modal>);
};
export default DeclaredDifficultyHybridModal;
